export const DRY_RUN_SUFFIX = '_dryrun'

export const NOTEXISTENT_TABLE_SUFFIX = '_notexistenttable'

export const MILES_TO_M = 1609.34

export const KM_TO_M = 1000

export const DEGREES_TO_M = 111.319

export const WORKFLOW_CONTROL_CODE_START_MARKER = '-- BEGIN CONTROL CODE'

export const WORKFLOW_CONTROL_CODE_END_MARKER = '-- END CONTROL CODE'
